import React, { Children, memo } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface Product {
  id: number;
  title: string;
  description: string;
  image: string;
  link: string;
  imageFit?: 'cover' | 'contain';
  imageBg?: string;
}
export function ProductGrid() {
  // TODO: User will provide real product URLs - replace '#' with actual links
  const products: Product[] = [{
    id: 1,
    title: 'Sistema Integral de Intervención en Tartamudez, Disfluencia y Disfemia™',
    description: '540 fichas clínicas organizadas por diagnóstico, edad y objetivo. Para fonoaudiólogas, psicopedagogas y neurolingüistas que necesitan un sistema completo para trabajar la fluencia del habla — sin improvisar más.',
    image: 'https://cdn.magicpatterns.com/uploads/oGVn5iWCVYiYjMfSLKJ1AF/WhatsApp_Image_2026-05-11_at_3.58.56_PM-removebg-preview.png',
    link: 'https://intervencion.librosdigitales.pro/',
    imageFit: 'contain',
    imageBg: 'bg-gradient-to-br from-[#f5efe6] to-[#faf6f0]'
  }, {
    id: 2,
    title: 'Kit Clínico Cognitivo™',
    description: 'Material de evaluación e intervención cognitiva organizado y listo para aplicar. Para profesionales que trabajan funciones ejecutivas, atención y memoria sin tener que armar todo desde cero.',
    image: 'https://cdn.magicpatterns.com/uploads/bHJ8RUbAoA6sJ7d7uGwZma/clinico_cognitivo.png',
    link: 'https://cognitivo.librosdigitales.pro/',
    imageFit: 'contain',
    imageBg: 'bg-gradient-to-br from-[#f5efe6] to-[#faf6f0]'
  }, {
    id: 7,
    title: 'Comprensión Lectora™',
    description: 'Fichas y actividades organizadas por nivel y edad para trabajar comprensión lectora con criterio clínico. Listo para imprimir y usar en sesión o en el aula.',
    image: 'https://cdn.magicpatterns.com/uploads/19qyZGv1m7nvSqd6vyx9yD/comprension_lectora.png',
    link: 'https://comprension.librosdigitales.pro/',
    imageFit: 'contain',
    imageBg: 'bg-gradient-to-br from-[#f5efe6] to-[#faf6f0]'
  }, {
    id: 9,
    title: 'Mega Pack de Intervención Fonoaudiológica Infantil™',
    description: '6 tomos interconectados (~560 páginas) para niños de 3 a 12 años. Lenguaje, lectoescritura, funciones ejecutivas, regulación, sistema estomatognático e informes. Para fonoaudiólogas que quieren dejar de improvisar y demostrar avances a las familias.',
    image: 'https://cdn.magicpatterns.com/uploads/oibcp143xV7P9zD5jRbQa1/fonoaudiologa_mock_up.png',
    link: 'https://fonoaudiologa.librosdigitales.pro/',
    imageFit: 'contain',
    imageBg: 'bg-gradient-to-br from-[#f5efe6] to-[#faf6f0]'
  }, {
    id: 10,
    title: 'MegaPack Psicopedagógico Profesional™',
    description: '1 año de material listo para usar con sistemas para TDAH, Dislexia y TEA: 24 sesiones estructuradas, +100 páginas de material clínico, planillas de seguimiento y reportes para padres. Para psicopedagogas que quieren recuperar sus tardes libres.',
    image: 'https://cdn.magicpatterns.com/uploads/sVbihAFRy8D6RQ2fpzaU3s/mock_up_psicopedagoga.png',
    link: 'https://psicopedagoga.librosdigitales.pro/',
    imageFit: 'contain',
    imageBg: 'bg-gradient-to-br from-[#f5efe6] to-[#faf6f0]'
  }, {
    id: 3,
    title: 'Mega Pack Terapéutico™',
    description: '24 sesiones terapéuticas completas con fichas, protocolos y registros clínicos. Para psicólogas que quieren entrar a cada sesión con orden, criterio y menos desgaste.',
    image: 'https://cdn.magicpatterns.com/uploads/wAGiuUc9GBhW85Fz2uxYer/psicologa_mock_up.png',
    link: '#',
    imageFit: 'contain',
    imageBg: 'bg-gradient-to-br from-[#f5efe6] to-[#faf6f0]'
  }, {
    id: 4,
    title: 'Mega Pack Intervención en Dislexia™',
    description: '72 actividades estructuradas de lengua y matemática, con seguimiento y comunicación con familias incluidos. Para dejar de inventar actividades semana a semana.',
    image: 'https://cdn.magicpatterns.com/uploads/5W23F1sjTsypCTarAZN3wQ/dislexia_mock_up.png',
    link: '#',
    imageFit: 'contain',
    imageBg: 'bg-gradient-to-br from-[#f5efe6] to-[#faf6f0]'
  }, {
    id: 5,
    title: 'Mega Pack Intervención en TDAH™',
    description: '+120 fichas terapéuticas con protocolos, registros y trabajo con familias. El sistema que necesitás cuando llega un caso de TDAH y no tenés tiempo de improvisar.',
    image: 'https://cdn.magicpatterns.com/uploads/qYY1GxBRegN6rkHZECfP35/tdah_mock_up.png',
    link: '#',
    imageFit: 'contain',
    imageBg: 'bg-gradient-to-br from-[#f5efe6] to-[#faf6f0]'
  }, {
    id: 6,
    title: 'Alfabetización en Autismo™',
    description: 'Material especializado para trabajar lectura y escritura con niños con TEA. Adaptado al ritmo, estilo y necesidades de cada etapa del proceso.',
    image: 'https://cdn.magicpatterns.com/uploads/uXX7AKxU5FsrQskCbm9qgT/alfa_mock_up.png',
    link: '#',
    imageFit: 'contain',
    imageBg: 'bg-gradient-to-br from-[#f5efe6] to-[#faf6f0]'
  }, {
    id: 8,
    title: 'Mega Pack Aula Real™ — Inclusión en el Aula',
    description: 'Sistema completo para docentes de nivel inicial y primario. 6 tomos + materiales listos para incluir alumnos con TDAH, Dislexia y TEA sin rehacer toda la planificación.',
    image: 'https://cdn.magicpatterns.com/uploads/jg8SAUPzQKY3HByQHtDw38/aula_real_mock_up.png',
    link: '#',
    imageFit: 'contain',
    imageBg: 'bg-gradient-to-br from-[#f5efe6] to-[#faf6f0]'
  }];
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <section id="productos" className="w-full bg-brand-bg py-16 md:py-24" data-id="element-49">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-51">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-primary mb-4 font-serif" data-id="element-52">
            Elegí el sistema que necesitás
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-53">
            Hacé click en cada producto para ver la descripción completa, la
            oferta y el acceso a la descarga.
          </p>
        </motion.div>

        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-54">
          {products.map(product => <motion.a key={product.id} href={product.link} target={product.link !== '#' ? '_blank' : undefined} rel={product.link !== '#' ? 'noopener noreferrer' : undefined} variants={item} whileHover={{
          y: -8,
          transition: {
            duration: 0.2
          }
        }} className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 flex flex-col" data-id="element-55">
              <div className={`relative overflow-hidden aspect-[3/2] ${product.imageBg ?? ''}`} data-id="element-56">
                <img src={product.image} alt={product.title} className={`w-full h-full ${product.imageFit === 'contain' ? 'object-contain p-2' : 'object-cover'} group-hover:scale-105 transition-transform duration-300`} data-id="element-57" />
                {product.imageFit !== 'contain' && <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-58" />}
              </div>

              <div className="p-6 flex flex-col flex-grow" data-id="element-59">
                <h3 className="text-xl font-bold text-brand-primary mb-3 leading-tight font-serif" data-id="element-60">
                  {product.title}
                </h3>
                <p className="text-gray-600 mb-4 flex-grow leading-relaxed" data-id="element-61">
                  {product.description}
                </p>
                <div className="flex items-center text-brand-accent font-semibold group-hover:gap-2 transition-all" data-id="element-62">
                  Ver material
                  <ArrowRight className="w-5 h-5 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-63" />
                </div>
              </div>
            </motion.a>)}
        </motion.div>
      </div>
    </section>;
}